import { WikiInspectionType } from '../../api/jurisdiction';
import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    saveWikiPermitting: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiPermitting'],
    }),
    getWikiPermitting: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting/${arg.id}/`,
          method: 'GET',
        };
      },
      providesTags: ['wikiPermitting'],
    }),
    updatePermitting: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting/${arg.id}/`,
          method: 'PATCH',
          body: arg,
        };
      },
      invalidatesTags: ['wikiPermitting'],
    }),
    updateWikiPermittingDocument: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting-documents/${arg.id}/`,
          method: 'PATCH',
          body: arg.frm,
        };
      },
      invalidatesTags: ['wikiDocument'],
    }),
    deleteWikiPermittingDocument: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting-documents/${arg.id}/`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['wikiDocument'],
    }),
    saveWikiPermittingDocument: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting-documents/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiDocument'],
    }),
    getWikiPermittingDocument: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting-documents/`,
          method: 'GET',
          params: arg,
        };
      },
      providesTags: ['wikiDocument'],
    }),
    downloadWikiPermittingDocuments: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-permitting-documents/download/`,
          method: 'POST',
          body: arg,
        };
      },
    }),
  }),
});

export const {
  useSaveWikiPermittingMutation,
  useGetWikiPermittingQuery,
  useUpdatePermittingMutation,
  useGetWikiPermittingDocumentQuery,
  useSaveWikiPermittingDocumentMutation,
  useUpdateWikiPermittingDocumentMutation,
  useDeleteWikiPermittingDocumentMutation,
  useDownloadWikiPermittingDocumentsMutation,
} = api;
